import { createContext, useContext } from 'react'

export const ConsultContext = createContext()

export const ConsultProvider = ConsultContext.Provider
export const ConsultConsumer = ConsultContext.Consumer

export const useConsultContext = () => useContext(ConsultContext)
